import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const fwWingstopStorePerformance: IConfigsType = {
  'fw_wingstop-store-base-r3d9tnva': {
    '/:brand/store_detail': {
      variables: [
        'date',
        'fwWingstopRevenueCenterSales',
        {
          type: 'lastTimeRange',
          optionItems: [
            { timeFrame: 'days', lastDateRangeNumber: 7 },
            { timeFrame: 'weeks', lastDateRangeNumber: 4 },
            { timeFrame: 'periods', lastDateRangeNumber: 3 },
            { timeFrame: 'periods', lastDateRangeNumber: 13 },
          ],
        },
      ],
      storePerformanceTitle: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      groupFilter: {
        api: 'locationFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
      },
      storePerformanceList: {
        type: 'list',
        api: 'fwWingstopListStorePerformanceKpis',
        fieldWidth: '250px',
        fields: [
          {
            content: {
              key: 'netSales',
            },
            bottom: 'Net Sales',
          },
          {
            content: {
              key: 'netSalesPercentageDiffToLastYear',
            },
            bottom: 'SSS %',
          },
          {
            content: {
              key: 'checkCount',
            },
            bottom: 'Check Count',
          },
          {
            content: {
              key: 'checkAverage',
              decimal: 2,
            },
            bottom: 'Check Average',
          },
          {
            content: {
              key: 'actualFoodCostPercentage',
            },
            bottom: 'COGS %',
          },
        ],
      },
      storePerformanceTable: {
        type: 'table-v2',
        api: 'fwWingstopStorePerformance',
        row: {
          pinning: {
            bottom: ['ptdActual', 'ptdBudget', 'ptdDifference'],
          },
          background: '<%- index % 2 ? colors.Porcelain : "" %>',
        },
        columns: [
          {
            key: 'date',
            width: '275px',
            useDangerouslySetInnerHTML: true,
          },
          {
            key: 'netSales',
            title: 'Net Sales',
            align: 'center',
            width: '200px',
            color: 'black',
          },
          {
            key: 'actualFoodCost',
            title: 'COGS',
            align: 'center',
            width: '200px',
            color: 'black',
          },
          {
            key: 'actualFoodCostPercentage',
            title: 'COGS %',
            align: 'center',
            width: '200px',
            color: 'black',
          },
          {
            key: 'laborActualCost',
            title: 'Hourly Labor',
            align: 'center',
            width: '200px',
            color: 'black',
          },
          {
            key: 'laborActualPercent',
            title: 'Hourly Labor %',
            align: 'center',
            width: '200px',
            color: 'black',
          },
        ],
      },

      // // Temporarily hide this section because we don't have NBO day-part data in the Unified Endpoint
      // dayPartTableAndChart: {
      //   type: 'grid',
      //   children: {
      //     dayPart: {
      //       type: 'table-v2',
      //       api: 'fwWingstopLocationDayPart',
      //       title: 'Day Part',
      //       row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
      //       columns: [
      //         {
      //           key: 'name',
      //           title: 'Day Part',
      //           sortable: true,
      //           width: '250px',
      //         },
      //         {
      //           key: 'sales',
      //           title: 'Sales',
      //           unit: 'dollar',
      //           sortable: true,
      //           width: '200px',
      //         },
      //         {
      //           key: 'percentSales',
      //           title: '% Net Sales',
      //           sortable: true,
      //           width: '200px',
      //         },
      //       ],
      //     },
      //     dayPartPieChart: {
      //       type: 'pie-chart',
      //       api: 'fwWingstopLocationDayPartPie',
      //       width: 400,
      //       label: 'name',
      //       datasets: [
      //         {
      //           key: 'netSales',
      //           label: 'nameWithPercentage',
      //           borderColor: COLORS.background,
      //           backgroundColor: [
      //             COLORS.Plum,
      //             COLORS.Mango,
      //             COLORS.Basil,
      //             COLORS.DarkOrchid,
      //             COLORS.Acai,
      //             COLORS.Pomodoro,
      //           ],
      //           hoverOffset: 4,
      //         },
      //       ],
      //       scaleTypes: {
      //         x: {
      //           type: 'price',
      //         },
      //       },
      //     },
      //   },
      // },

      revenueCenterBreakdownTable: {
        type: 'table-v2',
        api: 'fwWingstopLocationRevenueCenter',
        title: 'Revenue Center',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'name',
            title: 'Revenue Center',
            sortable: true,
            width: '250px',
          },
          {
            key: 'sales',
            title: 'Net Sales',
            unit: 'dollar',
            sortable: true,
            width: '200px',
          },
          {
            key: 'percentSales',
            title: '% Net Sales',
            sortable: true,
            width: '200px',
          },
        ],
      },
      revenueCenterTrendSalesFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Sales Trend',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
          },
        },
      },
      revenueCenterTrendSales: {
        type: 'bar-chart',
        api: 'fwWingstopTrendLocationRevenueCenterSales',
        width: 1100,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'sales_total_sales',
            label: 'Total Sales',
            borderColor: COLORS.Chalkboard,
            backgroundColor: COLORS.Chalkboard,
          },
          {
            key: '<%- JSON(fwWingstopRevenueCenterSales?.options) %>',
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
          },
        },
        options: {
          scales: {
            x: {
              stacked: true,
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
            y: {
              stacked: true,
            },
          },
        },
      },
      discountCompAndLabor: {
        type: 'grid',
        children: {
          // // Temporarily hide this section because detailed discount data in the Unified Endpoint might be wrong. It might need some work to fix them.
          // discountComp: {
          //   type: 'table-v2',
          //   api: 'locationDiscountComp',
          //   row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
          //   title: 'Comps',
          //   columns: [
          //     {
          //       key: 'name',
          //       title: 'Comps',
          //       sortable: true,
          //       width: '250px',
          //     },
          //     {
          //       key: 'amount',
          //       title: 'Amount',
          //       unit: 'dollar',
          //       sortable: true,
          //       width: '200px',
          //     },
          //     {
          //       key: 'percentSales',
          //       title: '% Net Sales',
          //       sortable: true,
          //       width: '200px',
          //     },
          //   ],
          // },

          laborOverview: {
            type: 'table-v2',
            api: 'fwWingstopLocationLaborOverview',
            row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
            title: 'Labor Overview',
            columns: [
              {
                key: 'name',
                title: ' ',
                width: '150px',
              },
              {
                key: 'value',
                title: ' ',
                align: 'right',
                width: '150px',
              },
            ],
          },
        },
      },
    },
  },
}

export default fwWingstopStorePerformance
